import React, { useEffect, useState } from "react";
import {
  errorSnackbar,
  successSnackbar,
} from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import copyNodeIcon from "../copy-node-icon.svg";
import styles from "./tsid-container.module.scss";
import { useI18N } from "@src/language/language-context";

interface TsidContainerPropTypes {
  tsid: string | undefined | null;
}

const cssClassName = "tsid-container";

export const TsidContainer = ({ tsid }: TsidContainerPropTypes) => {
  const i18n = useI18N();
  const [localTsid, setLocalTsid] = useState(undefined);

  const texts = {
    tsidLabel: i18n("modules.tsidContainer.tsidLabel"),
    tsidTooltip: i18n("modules.tsidContainer.tsidTooltip"),
    tsidLoadingMessage: i18n("modules.tsidContainer.tsidLoadingMessage"),
    tsidNotAvailableMessage: i18n(
      "modules.tsidContainer.tsidNotAvailableMessage",
    ),
    tsidSnackbarSuccess: i18n("modules.tsidContainer.tsidSnackbarSuccess"),
    tsidErrorMessage: i18n("modules.tsidContainer.tsidErrorMessage"),
  };

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      successSnackbar(texts.tsidSnackbarSuccess);
    } catch (err) {
      errorSnackbar(texts.tsidErrorMessage);
    }
  };

  const copyTsidToClipBoard = () => {
    copyToClipboard(tsid);
  };

  useEffect(() => {
    if (tsid !== undefined) {
      setLocalTsid(tsid !== null ? tsid : texts.tsidNotAvailableMessage);
    } else {
      setLocalTsid(texts.tsidLoadingMessage);
    }
  }, [tsid]);

  return (
    <>
      {tsid !== undefined ? (
        <div className={styles[cssClassName]}>
          <div className={styles[`${cssClassName}__id-wrapper`]}>
            <div className={styles[`${cssClassName}__id-label-wrapper`]}>
              <div
                className={styles[`${cssClassName}__id-label-wrapper-label`]}
              >
                {texts.tsidLabel}
              </div>
              {tsid && (
                <div
                  className={styles[`${cssClassName}__id-label-wrapper-button`]}
                >
                  <IconButton
                    fun={copyTsidToClipBoard}
                    icon={copyNodeIcon}
                    tooltip={texts.tsidTooltip}
                    tooltipPosition={"left"}
                  />
                </div>
              )}
            </div>
            <div className={styles[`${cssClassName}__id-value-wrapper`]}>
              <span>{localTsid}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles[cssClassName]}>
          <div className={styles[`${cssClassName}__id-wrapper`]}>
            <div className={styles[`${cssClassName}__id-label-wrapper`]}>
              <div
                className={styles[`${cssClassName}__id-label-wrapper-label`]}
              >
                {texts.tsidLabel}
              </div>
            </div>
            <div className={styles[`${cssClassName}__id-value-wrapper`]}>
              <span>{localTsid}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
